export const ERROR_SCREEN_ERROR_TYPE = {
    INVALID_CART : "INVALID_CART"
}